/*
 * The reducer takes care of state changes in our app through actions
 */

import invariant from 'invariant'
import {
  CHANGE_FORM,
  SET_AUTH,
  SENDING_REQUEST,
  REQUEST_ERROR,
  CLEAR_ERROR,
  CHANGE_FORM_FORGOT,
  SHOW_PROGRESS_BAR,
  HIDE_PROGRESS_BAR,
  SHOW_LOADING_SPINNER,
  CHANGE_FORM_BUSINESS,
  CHANGE_BUSINESS_TYPES_DATA,
  SET_AUTH_FROM_LOCAL,
  CHANGE_BUSINESS_CATEGORIES_DATA,
  CHANGE_FORM_REGISTER,
  REDIRECT_TO,
  LOAD_RESET_PASSWORD,
  CHANGE_FORM_RESET_PASSWORD,
  SET_PREPARE_ENCRYPTION,
  SET_PROFILE,
  CLEAR_REGISTER_FORM,
  SET_IS_REGISTERED,
  SET_RESEND_VERIFICATION_EMAIL_STATE,
  DASHBOARD_SHOW_MODAL_OUTLET_MOBILE,
  SET_AUTH_FROM_API
} from 'actions/constants'
import {SAVE_UPLOAD_IMAGE} from 'actions/uploadImage/constants'
import {loggedIn} from 'api/auth'
import { isFSA } from 'flux-standard-action'
import * as sentryLogin from 'sentry/login'
const store = require('store')

// The initial application state
let initialState = {
  formState: {
    email: '',
    password: ''
  },
  formRegState: {
    email: '',
    password: '',
    confpassword: ''
  },
  forgotState: {
    email: ''
  },
  businessState: {
    business_name: '',
    business_type: '',
    business_category: '',
    business_address: '',
    business_city: '',
    business_province: '',
    business_postal_code: '',
    user_first_name: '',
    user_last_name: '',
    user_phone: ''
  },
  businessTypesState: [],
  businessCategoriesState: [],
  hasError: false, // determine if the currentState hasError
  error: {}, // error object - based on FSA (Flux Standard Action), this must be Error() object
  currentlySending: false,
  loggedIn: loggedIn(),
  loadingBar: 0,
  user: null, // object of authenticated user. null if not authenticated
  outlets: [],
  currentOutlet: [],
  resetPasswordState: {
    token_error: true,
    message: '',
    userFullName: ''
  },
  encryption: {
    public_modulus: '',
    public_exponent: '',
    key: ''
  },
  showLoadingSpinner: false,
  isRegistered: false,
  resendVerificationEmail: {
    isModalShow: false,
    headerMessage: 'Error',
    bodyMessage: '',
    modalStatus: ''
  },
  showModalOutletMobile: false
}

// Takes care of changing the application state
function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  const {payload = {}, error = null} = action

  // check if action has key 'error' then hasError must be changed to true
  let hasError = false
  if (error) {
    hasError = true
  }

  switch (action.type) {
    case CHANGE_FORM:
      return {...state, hasError, formState: payload.newFormState}
    case SET_AUTH:
      payload.user && store.set(`response:login`, JSON.stringify(payload.user))
      sentryLogin.setUserContext({profile: payload.user})
      return {...state, hasError, loggedIn: payload.newAuthState, user: payload.user}
    case CHANGE_FORM_REGISTER:
      return {...state, hasError, formRegState: payload.newFormRegState}
    case CHANGE_FORM_FORGOT:
      return {...state, hasError, forgotState: payload.newForgotState}
    case CHANGE_FORM_BUSINESS:
      return {...state, hasError, businessState: payload.newBusinessState}
    case SENDING_REQUEST:
      return {...state, hasError, currentlySending: payload.sending}
    case REQUEST_ERROR:
      return {...state, hasError, error: payload.error}
    case CLEAR_ERROR:
      return {...state, hasError: false, error}
    case SHOW_PROGRESS_BAR:
      return {...state, hasError, loadingBar: (state.loadingBar + 30)}
    case SHOW_LOADING_SPINNER:
      return {...state, hasError, showLoadingSpinner: payload.showLoadingSpinner}
    case HIDE_PROGRESS_BAR:
      return {...state, hasError, loadingBar: (state.loadingBar > 0 ? state.loadingBar - 30 : 0)}
    case CHANGE_BUSINESS_TYPES_DATA:
      return {...state, hasError, businessTypesState: payload.newBusinessTypes}
    case CHANGE_BUSINESS_CATEGORIES_DATA:
      return {...state, hasError, businessCategoriesState: payload.newBusinessCategories}
    case SET_AUTH_FROM_LOCAL:
      const loginResponse = store.get(`response:login`)
      let user = null
      if (loginResponse) {
        user = JSON.parse(loginResponse)
      }
      if (user) {
        sentryLogin.setUserContext({profile: user})
      }
      return {...state, hasError, loggedIn: !!user, user}
    case REDIRECT_TO:
      return {...state, hasError, url: payload.url}
    case LOAD_RESET_PASSWORD:
      return {...state, hasError, url: payload.token}
    case CHANGE_FORM_RESET_PASSWORD:
      return {...state, hasError, resetPasswordState: payload.resetPasswordState}
    case SET_PREPARE_ENCRYPTION:
      return {...state, hasError, encryption: payload.encryption}
    case SET_PROFILE:
      return {...state, user: payload.profile}
    case CLEAR_REGISTER_FORM:
      return {...state, formRegState: {email: '', password: '', confpassword: ''}}
    case SET_IS_REGISTERED:
      return {...state, isRegistered: payload.isRegistered}
    case SET_RESEND_VERIFICATION_EMAIL_STATE:
      return {...state, resendVerificationEmail: payload.resendVerificationEmail}
    case DASHBOARD_SHOW_MODAL_OUTLET_MOBILE:
      return {...state, showModalOutletMobile: payload.showModalOutletMobile}
    case SAVE_UPLOAD_IMAGE:
      return {...state, user: {...state.user, gravatar: payload.filename}}
    case SET_AUTH_FROM_API:
      const profileResponse = payload.data
      let profile = null
      if (profileResponse) {
        profile = profileResponse
        sentryLogin.setUserContext({profile})
      }
      return {...state, hasError, loggedIn: !!profile, user: profile}
    default:
      return {...state, hasError: false}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/index.js